import { Users, Home, GraduationCap, Eye, ShieldCheck } from "lucide-react";
import { KidAvatar } from "@/components/live/KidAvatar";
import { slotLabel } from "@/components/messages/BookCheckin";

const ICON = { family: Home, class: GraduationCap, group: Users };
const ago = (iso) => (iso ? new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "");

const Row = ({ t, active, onPick, me }) => {
  const Icon = ICON[t.kind];
  const other = t.members.find((m) => m.id !== me) || t.members[0];
  return (
    <button onClick={() => onPick(t.id)} data-testid={`thread-${t.id}`}
      className={`w-full text-left flex items-center gap-3 px-3 py-3 rounded-2xl transition-colors ${active ? "bg-[#2C4A3E] text-white" : "hover:bg-[#F1EADB]"}`}>
      {Icon ? <span className={`w-10 h-10 rounded-full grid place-items-center shrink-0 ${active ? "bg-white/15" : "bg-[#F1EADB] text-[#2C4A3E]"}`}><Icon className="w-5 h-5" /></span>
        : other?.role === "student" ? <KidAvatar a={other.avatar} className="w-10 h-10" />
        : <span className="w-10 h-10 rounded-full bg-[#E8B4B8] grid place-items-center font-semibold text-[#2C4A3E] shrink-0">{other?.name[0]}</span>}
      <span className="flex-1 min-w-0">
        <span className="flex items-center gap-1.5"><b className="text-sm truncate">{t.name}</b>{t.monitored && <ShieldCheck className="w-3.5 h-3.5 shrink-0 opacity-60" aria-label="Parent-monitored" />}</span>
        {t.about && <span className={`block text-[10px] uppercase tracking-wider ${active ? "text-white/60" : "text-[#C87D53]"}`} data-testid={`thread-about-${t.id}`}>About: {t.about.join(" & ") || "your student"}</span>}
        <span className={`block text-xs truncate ${active ? "text-white/70" : "text-stone-500"}`}>{t.last_text || "No messages yet"}</span>
        {t.show_next && <span className={`block text-[11px] truncate ${active ? "text-white/80" : "text-[#C87D53]"}`} data-testid={`thread-next-${t.id}`}>{t.next_slot ? `Next open: ${slotLabel(t.next_slot.start)}` : "No open check-in times"}</span>}
      </span>
      <span className="flex flex-col items-end gap-1 shrink-0">
        <span className={`text-[10px] ${active ? "text-white/60" : "text-stone-400"}`}>{ago(t.last_at)}</span>
        {t.unread > 0 && <span data-testid={`thread-unread-${t.id}`} className="min-w-[18px] h-[18px] px-1 rounded-full bg-[#C87D53] text-white text-[10px] grid place-items-center">{t.unread}</span>}
      </span>
    </button>
  );
};

export const ThreadList = ({ data, tab, setTab, sel, onPick, me }) => {
  const list = tab === "monitor" ? data.monitoring : data.threads;
  return (
    <div>
      {data.monitoring.length > 0 || tab === "monitor" ? (
        <div className="flex gap-1 p-1 rounded-full bg-[#F1EADB] mb-3 text-xs" data-testid="thread-tabs">
          {[["chats", "My chats"], ["monitor", `Kids' teacher chats (${data.monitoring.length})`]].map(([v, l]) => (
            <button key={v} onClick={() => setTab(v)} data-testid={`thread-tab-${v}`} className={`flex-1 px-3 py-1.5 rounded-full ${tab === v ? "bg-[#2C4A3E] text-white" : "text-[#2C4A3E]"}`}>
              {v === "monitor" && <Eye className="w-3.5 h-3.5 inline mr-1" />}{l}</button>
          ))}
        </div>
      ) : null}
      <div className="space-y-1" data-testid="thread-list">
        {list.map((t) => <Row key={t.id} t={t} active={sel === t.id} onPick={onPick} me={me} />)}
        {!list.length && <p className="text-sm text-stone-500 px-3 py-6" data-testid="thread-list-empty">{tab === "monitor" ? "No teacher chats with your kids yet." : "No chats yet. Start one!"}</p>}
      </div>
    </div>
  );
};
